import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { apiError } from "@/lib/format";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

export function EditProfileModal({ open, onOpenChange, me, onDone }) {
  const [form, setForm] = useState({ name: me.name, address: me.address || "", dob: me.dob || "" });
  const [loading, setLoading] = useState(false);

  const save = async () => {
    setLoading(true);
    try {
      await api.put("/members/me", form);
      toast.success("Profile update ho gaya");
      onDone();
      onOpenChange(false);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="edit-profile-modal">
        <DialogHeader>
          <DialogTitle>Apni Profile Edit Karein</DialogTitle>
          <DialogDescription>Sirf naam, address aur DOB badal sakte hain.</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <Label>Naam</Label>
            <Input
              data-testid="edit-name-input"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />
          </div>
          <div className="space-y-2">
            <Label>Address</Label>
            <Textarea
              data-testid="edit-address-input"
              value={form.address}
              onChange={(e) => setForm({ ...form, address: e.target.value })}
            />
          </div>
          <div className="space-y-2">
            <Label>Date of Birth</Label>
            <Input
              type="date"
              data-testid="edit-dob-input"
              value={form.dob}
              onChange={(e) => setForm({ ...form, dob: e.target.value })}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button data-testid="edit-profile-save-btn" onClick={save} disabled={loading}>
            {loading ? "Saving…" : "Save"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export function WithdrawRequestModal({ open, onOpenChange, maxBalance }) {
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    const amt = parseFloat(amount);
    if (!amt || amt <= 0) return toast.error("Sahi amount daalein");
    setLoading(true);
    try {
      await api.post("/withdraw-request", { amount: amt, note });
      toast.success("Withdraw request bhej di gayi — admin approve karega");
      setAmount("");
      setNote("");
      onOpenChange(false);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="withdraw-request-modal">
        <DialogHeader>
          <DialogTitle>Withdraw Request</DialogTitle>
          <DialogDescription>Apne liye nikasi request bhejein. Available: ₹{maxBalance}</DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <Label>Amount (₹)</Label>
            <Input
              type="number"
              data-testid="withdraw-amount-input"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="2000"
            />
          </div>
          <div className="space-y-2">
            <Label>Reason (optional)</Label>
            <Textarea
              data-testid="withdraw-note-input"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button data-testid="withdraw-submit-btn" onClick={submit} disabled={loading}>
            {loading ? "Bhej rahe hain…" : "Request Bhejein"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
